import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from 'baseConfig';
const token = localStorage.getItem('token')


export const subCategoryServiceApi = createApi({
    reducerPath: 'subCategoryServiceApi',
    baseQuery: fetchBaseQuery({ baseUrl: `${BASE_URL}` }),
    tagTypes: ['SubCategory'],
    endpoints: (builder) => ({

        getAllSubCategory: builder.query({
            query: () => `/v1/subCategory`,
            providesTags: ['SubCategory'],
        }),

        getByCatId: builder.query({
            query: (id) => `/v1/subCategory/getByCatId/${id}`,
            providesTags: ['SubCategory'],
        }),

        getCountSubCategory: builder.query({
            query: () => `/v1/subCategory/count`,
            providesTags: ['SubCategory'],
        }),
        
        
        createSubCategory: builder.mutation({
            query: (values) => ({
                url: `/v1/subCategory/add`,
                method: 'POST',
                body: values,
                headers: {
                    'authorization': token,
                    'Content-Type': 'application/json',
                },
            }),
            invalidatesTags: ['SubCategory'],
        }),

        updateSubCategory: builder.mutation({
            query: ({ id, ...values }) => ({

                url: `/v1/subCategory/update/${id}`,
                method: 'PUT',
                headers: {
                    'authorization': token,
                    'Content-Type': 'application/json',
                },
                body: values,
            }),
            invalidatesTags: ['SubCategory'],
        }),

        deleteSubCategory: builder.mutation({
            query: (id) => ({
                url: `/v1/subCategory/delete/${id}`,
                method: 'DELETE',
                headers: {
                    'authorization': token,
                    'Content-Type': 'application/json',
                },
            }),
            invalidatesTags: ['SubCategory'],
        }),

        reorderSubCategories: builder.mutation({
            query: (values) => ({
                url: `/v1/subCategory/reorder`,
                method: 'PUT',
                headers: {
                    'authorization': token,
                    'Content-Type': 'application/json',
                },
                body: values,
            }),
            invalidatesTags: ['SubCategory'],
        }),
    }),
});

export const { useGetAllSubCategoryQuery, useCreateSubCategoryMutation, useDeleteSubCategoryMutation, useUpdateSubCategoryMutation, useGetByCatIdQuery, useGetCountSubCategoryQuery, useReorderSubCategoriesMutation } = subCategoryServiceApi;